import { render, staticRenderFns } from "./GateLockDamage.vue?vue&type=template&id=1af9d70f&scoped=true"
import script from "./GateLockDamage.vue?vue&type=script&lang=ts"
export * from "./GateLockDamage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af9d70f",
  null
  
)

export default component.exports